const actions = {
  FETCH_DEVICE_DETAILS_BEGIN: "FETCH_DEVICE_DETAILS_BEGIN",
  FETCH_DEVICE_DETAILS: "FETCH_DEVICE_DETAILS",
  FETCH_DEVICE_DETAILS_ERR: "FETCH_DEVICE_DETAILS_ERR",

  FETCH_ALL_QUESTIONS_LIST_BEGIN: "FETCH_ALL_QUESTIONS_LIST_BEGIN",
  FETCH_ALL_QUESTIONS_LIST: "FETCH_ALL_QUESTIONS_LIST",
  FETCH_ALL_QUESTIONS_LIST_ERR: "FETCH_ALL_QUESTIONS_LIST_ERR",

  CREATE_SURVEY_BEGIN: "CREATE_SURVEY_BEGIN",
  CREATE_SURVEY: "CREATE_SURVEY",
  CREATE_SURVEY_ERR: "CREATE_SURVEY_ERR",

  FETCH_ALL_SURVEY_LIST_BEGIN: "FETCH_ALL_SURVEY_LIST_BEGIN",
  FETCH_ALL_SURVEY_LIST: "FETCH_ALL_SURVEY_LIST",
  FETCH_ALL_SURVEY_LIST_ERR: "FETCH_ALL_SURVEY_LIST_ERR",

  FETCH_SURVEY_DETAILS_BEGIN: "FETCH_SURVEY_DETAILS_BEGIN",
  FETCH_SURVEY_DETAILS: "FETCH_SURVEY_DETAILS",
  FETCH_SURVEY_DETAILS_ERR: "FETCH_SURVEY_DETAILS_ERR",

  UPDATE_SURVEY_DETAILS_BEGIN: "UPDATE_SURVEY_DETAILS_BEGIN",
  UPDATE_SURVEY_DETAILS: "UPDATE_SURVEY_DETAILS",
  UPDATE_SURVEY_DETAILS_ERR: "UPDATE_SURVEY_DETAILS_ERR",

  FETCH_EXP_REPORT_DETAILS_BEGIN: "FETCH_EXP_REPORT_DETAILS_BEGIN",
  FETCH_EXP_REPORT_DETAILS: "FETCH_EXP_REPORT_DETAILS",
  FETCH_EXP_REPORT_DETAILS_ERR: "FETCH_EXP_REPORT_DETAILS_ERR",

  FETCH_EXP_BRANCH_REPO_DETAILS_BEGIN: "FETCH_EXP_BRANCH_REPO_DETAILS_BEGIN",
  FETCH_EXP_BRANCH_REPO_DETAILS: "FETCH_EXP_BRANCH_REPO_DETAILS",
  FETCH_EXP_BRANCH_REPO_DETAILS_ERR: "FETCH_EXP_BRANCH_REPO_DETAILS_ERR",

  FETCH_BRANCH_REPO_DETAILS_BEGIN: "FETCH_BRANCH_REPO_DETAILS_BEGIN",
  FETCH_BRANCH_REPO_DETAILS: "FETCH_BRANCH_REPO_DETAILS",
  FETCH_BRANCH_REPO_DETAILS_ERR: "FETCH_BRANCH_REPO_DETAILS_ERR",

  FETCH_QNANS_REPORT_BEGIN: "FETCH_QNANS_REPORT_BEGIN",
  FETCH_QNANS_REPORT: "FETCH_QNANS_REPORT",
  FETCH_QNANS_REPORT_ERR: "FETCH_QNANS_REPORT_ERR",

  FETCH_CASE_BR_REPORT_BEGIN: "FETCH_CASE_BR_REPORT_BEGIN",
  FETCH_CASE_BR_REPORT: "FETCH_CASE_BR_REPORT",
  FETCH_CASE_BR_REPORT_ERR: "FETCH_CASE_BR_REPORT_ERR",

  FETCH_CASER_OVER_REPORT_BEGIN: "FETCH_CASER_OVER_REPORT_BEGIN",
  FETCH_CASER_OVER_REPORT: "FETCH_CASER_OVER_REPORT",
  FETCH_CASER_OVER_REPORT_ERR: "FETCH_CASER_OVER_REPORT_ERR",

  FETCH_CASER_OVER_PERIOD_BEGIN: "FETCH_CASER_OVER_PERIOD_BEGIN",
  FETCH_CASER_OVER_PERIOD: "FETCH_CASER_OVER_PERIOD",
  FETCH_CASER_OVER_PERIOD_ERR: "FETCH_CASER_OVER_PERIOD_ERR",

  FETCH_EXCEL_REPORT_BEGIN: "FETCH_EXCEL_REPORT_BEGIN",
  FETCH_EXCEL_REPORT: "FETCH_EXCEL_REPORT",
  FETCH_EXCEL_REPORT_ERR: "FETCH_EXCEL_REPORT_ERR",

  UPDATE_PASSWORD_DETAILS_BEGIN: "UPDATE_PASSWORD_DETAILS_BEGIN",
  UPDATE_PASSWORD_DETAILS: "UPDATE_PASSWORD_DETAILS",
  UPDATE_PASSWORD_DETAILS_ERR: "UPDATE_PASSWORD_DETAILS_ERR",

  fetchDeviceDetailsBegin: () => {
    return {
      type: actions.FETCH_DEVICE_DETAILS_BEGIN,
    };
  },

  fetchDeviceDetails: (data) => {
    return {
      type: actions.FETCH_DEVICE_DETAILS,
      data,
    };
  },
  fetchDeviceDetailsErr: (err) => {
    return {
      type: actions.FETCH_DEVICE_DETAILS_ERR,
      err,
    };
  },

  fetchAllQuestionListBegin: () => {
    return {
      type: actions.FETCH_ALL_QUESTIONS_LIST_BEGIN,
    };
  },

  fetchAllQuestionList: (data) => {
    return {
      type: actions.FETCH_ALL_QUESTIONS_LIST,
      data,
    };
  },
  fetchAllQuestionListErr: (err) => {
    return {
      type: actions.FETCH_ALL_QUESTIONS_LIST_ERR,
      err,
    };
  },

  createSurveyBegin: () => {
    return {
      type: actions.CREATE_SURVEY_BEGIN,
    };
  },

  createSurvey: (data) => {
    return {
      type: actions.CREATE_SURVEY,
      data,
    };
  },
  createSurveyErr: (err) => {
    return {
      type: actions.CREATE_SURVEY_ERR,
      err,
    };
  },

  fetchAllSurveyListBegin: () => {
    return {
      type: actions.FETCH_ALL_SURVEY_LIST_BEGIN,
    };
  },

  fetchAllSurveyList: (data) => {
    return {
      type: actions.FETCH_ALL_SURVEY_LIST,
      data,
    };
  },
  fetchAllSurveyListErr: (err) => {
    return {
      type: actions.FETCH_ALL_SURVEY_LIST_ERR,
      err,
    };
  },

  fetchSurveyDetailsBegin: () => {
    return {
      type: actions.FETCH_SURVEY_DETAILS_BEGIN,
    };
  },

  fetchSurveyDetails: (data) => {
    return {
      type: actions.FETCH_SURVEY_DETAILS,
      data,
    };
  },
  fetchSurveyDetailsErr: (err) => {
    return {
      type: actions.FETCH_SURVEY_DETAILS_ERR,
      err,
    };
  },

  updateSurveyDetailsBegin: () => {
    return {
      type: actions.UPDATE_SURVEY_DETAILS_BEGIN,
    };
  },

  updateSurveyDetails: (data) => {
    return {
      type: actions.UPDATE_SURVEY_DETAILS,
      data,
    };
  },
  updateSurveyDetailsErr: (err) => {
    return {
      type: actions.UPDATE_SURVEY_DETAILS_ERR,
      err,
    };
  },

  fetchExpReportDetailsBegin: () => {
    return {
      type: actions.FETCH_EXP_REPORT_DETAILS_BEGIN,
    };
  },

  fetchExpReportDetails: (data) => {
    return {
      type: actions.FETCH_EXP_REPORT_DETAILS,
      data,
    };
  },
  fetchExpReportDetailsErr: (err) => {
    return {
      type: actions.FETCH_EXP_REPORT_DETAILS_ERR,
      err,
    };
  },

  fetchBrExpReportDetailsBegin: () => {
    return {
      type: actions.FETCH_EXP_BRANCH_REPO_DETAILS_BEGIN,
    };
  },

  fetchBrExpReportDetails: (data) => {
    return {
      type: actions.FETCH_EXP_BRANCH_REPO_DETAILS,
      data,
    };
  },
  fetchBrExpReportDetailsErr: (err) => {
    return {
      type: actions.FETCH_EXP_BRANCH_REPO_DETAILS_ERR,
      err,
    };
  },

  fetchBrReportDetailsBegin: () => {
    return {
      type: actions.FETCH_BRANCH_REPO_DETAILS_BEGIN,
    };
  },

  fetchBrReportDetails: (data) => {
    return {
      type: actions.FETCH_BRANCH_REPO_DETAILS,
      data,
    };
  },
  fetchBrReportDetailsErr: (err) => {
    return {
      type: actions.FETCH_BRANCH_REPO_DETAILS_ERR,
      err,
    };
  },

  fetchQnAnsReportBegin: () => {
    return {
      type: actions.FETCH_QNANS_REPORT_BEGIN,
    };
  },

  fetchQnAnsReport: (data) => {
    return {
      type: actions.FETCH_QNANS_REPORT,
      data,
    };
  },
  fetchQnAnsReportErr: (err) => {
    return {
      type: actions.FETCH_QNANS_REPORT_ERR,
      err,
    };
  },

  fetchCaseBrReportDetailsBegin: () => {
    return {
      type: actions.FETCH_CASE_BR_REPORT_BEGIN,
    };
  },

  fetchCaseBrReportDetails: (data) => {
    return {
      type: actions.FETCH_CASE_BR_REPORT,
      data,
    };
  },
  fetchCaseBrReportDetailsErr: (err) => {
    return {
      type: actions.FETCH_CASE_BR_REPORT_ERR,
      err,
    };
  },

  fetchCaseOverTimeDetailsBegin: () => {
    return {
      type: actions.FETCH_CASER_OVER_REPORT_BEGIN,
    };
  },

  fetchCaseOverTimeDetails: (data) => {
    return {
      type: actions.FETCH_CASER_OVER_REPORT,
      data,
    };
  },
  fetchCaseOverTimeDetailsErr: (err) => {
    return {
      type: actions.FETCH_CASER_OVER_REPORT_ERR,
      err,
    };
  },

  fetchCaseOverPeriodBegin: () => {
    return {
      type: actions.FETCH_CASER_OVER_PERIOD_BEGIN,
    };
  },

  fetchCaseOverPeriod: (data) => {
    return {
      type: actions.FETCH_CASER_OVER_PERIOD,
      data,
    };
  },
  fetchCaseOverPeriodErr: (err) => {
    return {
      type: actions.FETCH_CASER_OVER_PERIOD_ERR,
      err,
    };
  },

  fetchExcelReportBegin: () => {
    return {
      type: actions.FETCH_EXCEL_REPORT_BEGIN,
    };
  },

  fetchExcelReport: (data) => {
    return {
      type: actions.FETCH_EXCEL_REPORT,
      data,
    };
  },
  fetchExcelReportErr: (err) => {
    return {
      type: actions.FETCH_EXCEL_REPORT_ERR,
      err,
    };
  },

  updatePasswordDetailsBegin: () => {
    return {
      type: actions.UPDATE_PASSWORD_DETAILS_BEGIN,
    };
  },

  updatePasswordDetails: (data) => {
    return {
      type: actions.UPDATE_PASSWORD_DETAILS,
      data,
    };
  },
  updatePasswordDetailsErr: (err) => {
    return {
      type: actions.UPDATE_PASSWORD_DETAILS_ERR,
      err,
    };
  },
};

export default actions;
